import request from '@/utils/request'

// 招聘
export function appRecruitDetail(data) {
  return request({
    url: '/yg-plat-manage/appRecruitDetail/queryPage',
    method: 'post',
    data
  })
}